import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/Icon';
import type { TagProps } from './Tag.types';
import './tag.scss';

const Tag = ({ text, iconName, color, type, className, style, darkText, roundedFull, iconRight }: TagProps) => {
  const isDarkText = darkText ? "sb-tag--dark-text" : "";
  const isRoundedFull = roundedFull ? "sb-tag--rounded-full" : "";
  const isIconRight = iconRight ? "sb-tag--icon-right" : "";

  return (
    <span
      className={['sb-tag',
        `sb-tag--${type}`,
        `sb-tag--${color}`,
        isDarkText,
        className,
        isRoundedFull,
        isIconRight
      ].join(' ')}
      data-testid="sb-tag"
      style={{ ...style }}
    >
      {iconName &&
        <Icon
          className={isIconRight ? 'ml-xsm' : 'mr-xsm'}
          iconName={iconName}
          size={14}
        />
      }
      {text}
    </span>
  );
};

Tag.propTypes = {
  /**
 * Tag text
 */
  text: PropTypes.string,
  /**
* IconName
*/
  iconName: PropTypes.string,
  /**
* className
*/
  className: PropTypes.string,
  /**
* style
*/
  style: PropTypes.object,
  /**
* Color of tag
*/
  color: PropTypes.oneOf(['primary', 'secondary', 'custom']),
  /**
* type
*/
  type: PropTypes.oneOf(['fill', 'stroke']),
  /**
* darkText?
*/
  darkText: PropTypes.bool,
  /**
* roundedFull?
*/
  roundedFull: PropTypes.bool,
  /**
* iconRight?
*/
  iconRight: PropTypes.bool,
};

Tag.defaultProps = {
  text: "tag text",
  iconName: "",
  className: "",
  style: {},
  color: "primary",
  type: "fill",
  darkText: false,
  roundedFull: false,
  iconRight: false
};

export default Tag;